import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 78,
		height: 78,
		rx: 39,
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M27.5 38.5L37 48L53 32",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
